import { requestApi } from '../util/network'
// 获取货币列表
export const getCurrencyList =
() =>
  requestApi(
    '/Currency/currency_list',
    'POST',
    {

    },
    'member'
  )
// 获取单条货币信息
export const getCurrencyInfo =
    () =>
      requestApi(
        '/Currency/currency_info',
        'POST',
        {

        },
        'member'
      )
// 变更货币
export const editCurrency =
    (currency) =>
      requestApi(
        '/Currency/currency_edit',
        'POST',
        {
          'currency': currency
        },
        'member'
      )
